/* src/app/request-form/setup-incomplete-modal/setup-incomplete-modal.component.scss */
.cancel {
  padding-left: 30px;
  padding-bottom: 20px;
  padding-right: 20px;
  width: 553px;
}
.modal-header {
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
  border-bottom: none;
}
.modal-header h4 {
  font-size: 32px;
}
.modal-title {
  padding-left: 14px;
}
.modal-body {
  width: 450px;
  height: 36px;
  font-size: 14px;
  padding-bottom: 30px;
}
.modal-footer {
  padding-top: 20px;
  padding-bottom: 10px;
  border-top: none;
}
.btn {
  margin-top: 28px;
  height: 36px;
  border-radius: 100px;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
  font-size: 13px;
}
.btn-green {
  color: white;
  background-color: #00857D;
}
.btn-close {
  padding-right: 40px !important;
}
/*# sourceMappingURL=setup-incomplete-modal.component.css.map */
